import { isEmpty } from 'lodash';
import { useMemo } from 'react';

import {
  BulkCampaignType,
  BulkPatientItemDataFragment,
} from '../../../../data/types/api/graphql';
import { CustomFormattedMessage } from '../../../../elements/intl/custom-formatted-message';
import { BulkMessagesPatientListItem } from './bulk-messages-patient-list-item';

type BulkMessagesPatientListProps = {
  loading?: boolean;
  type?: BulkCampaignType | null;
  active?: boolean | null;
  items: BulkPatientItemDataFragment[];
  availableSlotsCount?: number | null;
  onClick?: (value: BulkPatientItemDataFragment) => void;
  onDelete?: (value: BulkPatientItemDataFragment) => void;
  onResend?: (value: BulkPatientItemDataFragment) => void;
};

export function BulkMessagesPatientList({
  loading = false,
  type,
  active,
  availableSlotsCount,
  onClick,
  onDelete,
  onResend,
  ...props
}: BulkMessagesPatientListProps) {
  const items = useMemo(() => props.items, [props.items]);

  if (loading) {
    return (
      <p>
        <CustomFormattedMessage id="common.loading" />
      </p>
    );
  }

  if (isEmpty(items)) {
    return (
      <p>
        <CustomFormattedMessage id="common.no-data" />
      </p>
    );
  }

  return (
    <div className="content-list">
      {items.map(option => (
        <div key={option.patient.id} className="content-list__item">
          <BulkMessagesPatientListItem
            availableSlotsCount={availableSlotsCount}
            type={type}
            active={active}
            patientItem={option}
            onClick={onClick}
            onDelete={onDelete}
            onResend={onResend}
          />
        </div>
      ))}
    </div>
  );
}
